import { HttpClient } from '@angular/common/http';
import { Component, OnInit } from '@angular/core';
import { DashboardData } from '../../models/dashboard.model';
import { Route, Router } from '@angular/router';
import { QuestionnaireAvailability, QuestionnaireService } from '../../service/questionnaire.service';
import { AlertService } from '../../service/alert.service';
import { CompanyService } from '../../service/company.service';
import { environment } from '../../environments/environment';
import { MatSpinner } from '@angular/material/progress-spinner';
import { Company } from '../../models/company.model';
import { CompanyInfo } from '../../shared/dto/models-dto';
import Swal from 'sweetalert2';
import { MatIcon } from "@angular/material/icon";
import { CommonModule } from '@angular/common';
import { AlertMessageComponent } from "../../shared/alert-message/alert-message.component";
import { TranslateModule, TranslateService } from '@ngx-translate/core';



@Component({
  selector: 'app-training-course',
  standalone: true,
  templateUrl: './training-course.component.html',
  styleUrl: './training-course.component.css',
  imports: [MatIcon, CommonModule, AlertMessageComponent, TranslateModule]
})
export class TrainingCourseComponent implements OnInit {

  dashboardData!: DashboardData;
  isQuestionnaireFilled = false;
  isQuestionnaireAvailable = false;
  tooltipMessage = '';
  isLoading = false;

  selectedFile?: File | null = null;
  selectedFileName: string | null = null;
  uploadMessage: string | null = null;
  isUploading = false;
  company : Company | null = null;

  constructor(private http: HttpClient, private route: Router,
    private questionnaireService: QuestionnaireService, private alertService: AlertService,
    private companyService: CompanyService, private translate: TranslateService) { }

  ngOnInit(): void {
    this.isLoading = true;
    this.isUploading = false;
    this.companyService.getCompany().subscribe({
      next: (data) => {
        this.company = data;
        this.isLoading = false;
        console.log(this.uploadMessage);
      },
      error: (err) => {
        this.isLoading = false;
        console.error('Errore nel caricamento dei dati dell\'azienda:', err);
      }
    });
  }

  downloadPdf(): void {

    if (this.company?.badgeDocumentBase64) {
      const byteCharacters = atob(this.company.badgeDocumentBase64);
      const byteNumbers = new Array(byteCharacters.length).fill(0).map((_, i) => byteCharacters.charCodeAt(i));
      const byteArray = new Uint8Array(byteNumbers);
      const blob = new Blob([byteArray], { type: 'application/pdf' });

      const url = window.URL.createObjectURL(blob);
      const a = document.createElement('a');
      a.href = url;
      a.download = 'badge-document.pdf'; 
      a.click();
      window.URL.revokeObjectURL(url);
    }
  }

  onFileSelected(event: Event): void {
    const input = event.target as HTMLInputElement;
    const file = input.files && input.files[0];
    if (!file) {
      this.selectedFile = null;
      this.selectedFileName = null;
      return;
    }
    if (file.type !== 'application/pdf') {
      this.alertService.errorKey('training-course.error-select-pdf-only');
      input.value = '';
      this.selectedFile = null;
      this.selectedFileName = null;
      return;
    }
    this.selectedFile = file;
    this.selectedFileName = file.name;
    this.uploadMessage = null;
  }

  onDrop(event: DragEvent): void {
    event.preventDefault();
    const file = event.dataTransfer && event.dataTransfer.files && event.dataTransfer.files[0];
    if (!file) return;
    if (file.type !== 'application/pdf') {
      this.alertService.errorKey('training-course.error-drop-pdf-only');
      return;
    }
    this.selectedFile = file;
    this.selectedFileName = file.name;
    this.uploadMessage = null;
  }

  uploadPdf(): void {

    const currentUrl = this.route.url;

    

    if (!this.selectedFile) {
      this.alertService.errorKey('training-course.error-no-file');
      return;
    }
    const maxSize = 5 * 1024 * 1024; // 5MB
    if (this.selectedFile.size > maxSize) {
      this.alertService.errorKey('training-course.error-max-size');
      return;
    }

    this.isUploading = true;
    const formData = new FormData();
    formData.append('badgeFile', this.selectedFile);

    this.companyService.uploadBadge(formData)
      .subscribe({
        next: () => {
          this.isUploading = false;
          this.uploadMessage = this.translate.instant('training-course.upload-success-message');
          this.alertService.successKey('training-course.upload-success-alert');
          this.selectedFile = null;
          this.selectedFileName = null;
          const inputEl = document.getElementById('pdfInput') as HTMLInputElement | null;
          if (inputEl) inputEl.value = '';
          this.ngOnInit();
        },
        error: (err) => {
          this.isUploading = false;
          this.uploadMessage = this.translate.instant('training-course.upload-failed-message');
          console.error('Upload error', err);
          this.alertService.errorKey('training-course.upload-failed-alert');
        }
      });
  }

  removePdf() {

    const currentUrl = this.route.url;

    Swal.fire({
      title: this.translate.instant('training-course.remove-confirm-title'),
      text: this.translate.instant('training-course.remove-confirm-text'),
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: this.translate.instant('common.yes'),
      cancelButtonText: this.translate.instant('common.cancel')
    }).then(result => {
        if (result.isConfirmed) {
        console.log('Confirmed');
        this.isUploading = true;
        const formData = new FormData();
        formData.append('badgeFile', new Blob(), '');

        this.companyService.uploadBadge(formData)
        .subscribe({
        next: () => {
          this.selectedFile = null;
          this.selectedFileName = null;
          this.uploadMessage = this.translate.instant('training-course.remove-success-message');
          const inputEl = document.getElementById('pdfInput') as HTMLInputElement | null;
          if (inputEl) inputEl.value = '';
          this.ngOnInit();
        },
        error: (err) => {
          this.isUploading = false;
          this.uploadMessage = this.translate.instant('training-course.upload-failed-message');
          console.error('Upload error', err);
          this.alertService.errorKey('training-course.upload-failed-alert');
        }
        });
        }
      });
    }

}

